module.exports = __webpack_public_path__ + "img/rejected.709765f7.png";